import { STATUS } from "@/constant/statusConstants";

const getBannerInitialValues = (showData = null) => {
  const data = showData?.data;
  return {
    name: data?.name || "",
    page: data?.page || "",
    language_type: data?.language_type || "",
    sport_type: data?.sport_type || "",
    sport_id: data?.sport_id || "",
    language_id: data?.language_id || "",
    url_redirect: data?.url_redirect || "",
    image_preview: data?.image_preview || "",
    status: data?.status || STATUS.INACTIVE,
  }
};

export default getBannerInitialValues;
